// extracted by mini-css-extract-plugin
export var cardLayout = "_a9-1";
export var paginationContainer = "_a9-0";